import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBean: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBean"><Path d="M19.2228 4.77723C22.414 7.96845 21.7672 13.7892 17.7782 17.7782C13.7892 21.7672 7.96845 22.414 4.77723 19.2228C1.58601 16.0315 2.23276 10.2108 6.22178 6.22178C10.2108 2.23276 16.0315 1.58601 19.2228 4.77723Z" stroke="currentColor" strokeWidth="1.5"/><Path d="M4 18C8.12903 9.65217 15.871 14.3478 20 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconBean;
